import './Style.scss';
import './styles/split-form.scss';

import "@fortawesome/fontawesome-free/css/all.min.css";
import 'bootstrap/dist/js/bootstrap.js';

// import Sidebar from './components/common/sidebar-component/Sidebar';
import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from './Layouts/Main/Main';
import RouteList from "./routes";
import Guards from './protected/protected-routes';
import CampaignLayout from './Layouts/Campaign/Campaign';
import AuthUser from './pages/components/authentication/auth';
import NotFound from './404/Not-Found';
import interceptor from './utils/interceptor';
import { AuthContextProvider } from './context/authContext';
import AuthGuard from './protected/auth.guard';
import UnaAuthGuard from './protected/unAuth.guard';
import { getUserInfo } from './utils/user-info';
import DonorPortalRoutes from './donor-portal/DonorPortalRoutes';
import { isDonorPortalDomain } from './donor-portal/portalPaths';

function App() {

  // The donors' own domain (REACT_APP_DONOR_PORTAL_DOMAIN) serves the Donor
  // Portal and nothing else, at its root. None of the admin app below -- its
  // routes, its AuthContext, its axios interceptor -- is set up there.
  if (isDonorPortalDomain()) {
    return (
      <div className='main-app'>
        <Routes>
          <Route path="/*" element={<DonorPortalRoutes />} />
        </Routes>
      </div>
    )
  }

  const userInfo = getUserInfo()
  //executing interceptor
  interceptor();
  
  //creating routes data for main layout start
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      return (
        <Route
          path={prop.path}
          element={
            prop?.isAuth === true ? 
            <AuthGuard role={prop.role}>
              {prop.component}
            </AuthGuard>
            : prop?.isAuth === false ?
             <UnaAuthGuard>
              {prop.component}
            </UnaAuthGuard> :
            prop.component
          }
          key={key}
        />
      )
    })
  }

  //creating routes data for main layout end


  return (
    <div className='main-app'>
      <AuthContextProvider>
      <Routes>
        {/* <Route element={<Guards.UnProtectedRoutes />}> */}
          {getRoutes(RouteList.DefaultRouteList)}
        {/* </Route> */}
        {/* <Route element={<Guards.ProtectedRoutes />}> */}
          <Route path="/" element={<MainLayout />}>
            {getRoutes(RouteList.MainRouteList)}
            {
              userInfo?.role === 2 ? 
              <Route index element={<Navigate to="/donations" />} /> : 
              <Route index element={<Navigate to="/admin/donations" />} />
            }
            
          </Route>

          <Route path="/layout" element={<CampaignLayout />}>
            {getRoutes(RouteList.CampaignRouteList)}
            <Route index element={<Navigate to="/campaigns" />} />
          </Route>

          {/* <Route path="authenticate/:token" element={<AuthUser />} /> */}
        {/* </Route> */}

        {/* <Route element={<Guards.ProtectedRoutes />}>
          <Route path='/campaign' element={<CampaignLayout />}>
            {getRoutes(RouteList.CampaignRouteList)}
          </Route>
        </Route> */}

        {/*
          Donor Portal.

          A top-level sibling on purpose: outside MainLayout, outside AuthGuard,
          and outside the admin AuthContext. Donors are not masjid
          administrators, so an admin session must neither grant nor deny access
          here, and the admin sidebar and navbar must not wrap a donor-facing
          page.

          It brings its own DonorAuthProvider, its own Cognito session and its
          own axios instance, so no donor state touches anything above.

          Once a donor domain is configured, this path only forwards there.

          React Router ranks by specificity rather than declaration order, so
          this static path wins over the "*" catch-all below it.
        */}
        <Route path="/donor-portal/*" element={<DonorPortalRoutes />} />

        <Route path="*" element={<NotFound />} />
        <Route>{getRoutes(RouteList.openRoute)}</Route>
      </Routes>
      </AuthContextProvider>
   
    </div>
  )
}

export default App;